import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLogin } from "../../PortalRunner/hooks/useLogin";
import { selectIsLoggedIn } from "../../Store/api/auth/authSelectors";

interface SecurePageProps {
  children: React.ReactNode;
}

export const SecurePage: React.FC<SecurePageProps> = ({ children }) => {
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const { handleLogin } = useLogin();

  useEffect(() => {
    if (isLoggedIn === false) {
      handleLogin();
    }
  }, [isLoggedIn, handleLogin]); // Effect dependency on isLoggedIn

  if (!isLoggedIn) {
    return <h3>Redirecting...</h3>;
  }

  return <>{children}</>;
};
